// extracted by mini-css-extract-plugin
module.exports = {"mainBlock":"Main_mainBlock__2bzv-","mainContainer":"Main_mainContainer__2D9bF","particles":"Main_particles__2N2Ai","text":"Main_text__tOqw9","photo":"Main_photo__jDAW7"};